var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('h5',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('md-tabs',{staticClass:"tabs",attrs:{"md-alignment":"centered"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }